



































import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { IEditForm } from '@/pages/campaign/adset/editingTypes';
import { CampaignInfoResponse } from '@/pages/campaign/editingTypes';

import { ORIGIN_FORMAT } from '@/utils';

@Component<AdsetEditingBrief>({
    name: 'AdsetEditingBrief',
})
export default class AdsetEditingBrief extends Vue {
    @Prop({ type: Object, required: true }) private formData!: IEditForm;
    @Prop({ type: Object, required: true }) private campaignData!: CampaignInfoResponse;

    private compTerms = compTerms;
    
    get campaignDate() {
        if (this.campaignData.date) {
            if (this.campaignData.date[1] === '') return moment(this.campaignData.date[0]).format('YYYY-MM-DD') + ' ~ 계속';
            return moment(this.campaignData.date[0]).format('YYYY-MM-DD') + ' ~ ' + moment(this.campaignData.date[1]).format('YYYY-MM-DD');
        }
        return '';
    }

    get campaignBudget() {
        if (this.campaignData.budget) {
            if (this.campaignData.budget.limited) {
                return (this.campaignData.budget.type === 'total' ? '총 ' : '일일 ') + ORIGIN_FORMAT.NumberFormatOrigin(this.campaignData.budget.value) + '원';
            } else {
                return compTerms.form.campaign.budget.inactive
            }
        }
        return  '';
    }

    get date() {
        if (this.formData.date) {
            if (this.formData.date[0] === '') return '';
            if (this.formData.date[1] === '') return moment(this.formData.date[0]).format('YYYY-MM-DD') + ' ~ 계속';
            return moment(this.formData.date[0]).format('YYYY-MM-DD') + ' ~ ' + moment(this.formData.date[1]).format('YYYY-MM-DD');
        }
        return '';
    }
}
